@if (cart) {
  <button (click)="submitForm()" type="submit" class="btn btn-black">
    {{ 'common.pay' | cxTranslate }}
    {{ cart?.totalPriceWithTax?.formattedValue }}
  </button>
}